import { TableColumn } from '@/classes'

const Columns = [
  new TableColumn('Remark Description', 'REMARKDESCRIPTION', true, 'asc', 'left'),
  new TableColumn('Active', 'ACTIVE', true, 'asc', 'centered'),
  new TableColumn('', 'action', false, 'desc', 'centered')
]

export { Columns }
